(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/collections/matchlist.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/collections/matchlist.js');

'use strict';

svs.game_results.collections.MatchList = Backbone.Collection.extend({
  model: svs.game_results.models.Match,
  updateMatches(drawEvents) {
    for (let i = 0; i < this.models.length; i++) {
      this.models[i].updateMatch(drawEvents[i].match);
    }
  }
});

 })(window);